import { useState, type ComponentPropsWithoutRef } from "react";
import clsx from "clsx";

type PasswordFieldProps = Omit<ComponentPropsWithoutRef<"input">, "type">;

const PasswordField = ({ className, ...props }: PasswordFieldProps) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="relative">
      <input
        type={isVisible ? "text" : "password"}
        className={clsx("w-full pr-20", className)}
        {...props}
      />
      <button
        type="button"
        onClick={() => setIsVisible((current) => !current)}
        className="absolute inset-y-0 right-3 my-auto h-fit text-sm font-medium text-myteengig-primary transition hover:text-myteengig-primary-hover"
      >
        {isVisible ? "Hide" : "Show"}
      </button>
    </div>
  );
};

export default PasswordField;
